import { put, call, all } from 'redux-saga/effects';
import _ from 'lodash';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getTeams() {
  try {
    const teams = yield call(API.getTeams);
    yield put({ type: actionTypes.TEAMS_GET_SUCCESS, teams });
  } catch (error) {
    yield put({ type: actionTypes.TEAMS_GET_ERROR, error });
  }
}

export function* getTeam({ teamId }) {
  try {
    const team = yield call(API.getTeam, teamId);
    yield all([put({ type: actionTypes.TEAM_GET_SUCCESS, team })]);
  } catch (error) {
    yield put({ type: actionTypes.TEAM_GET_ERROR, error });
  }
}

export function* createTeam({ team }) {
  try {
    const result = yield call(API.createTeam, team);

    if (result.id) {
      yield put({ type: actionTypes.TEAM_CREATE_SUCCESS, team: result });
    } else {
      yield put({ type: actionTypes.TEAM_CREATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.TEAM_CREATE_ERROR, error });
  }
}

export function* updateTeam({ teamId, team }) {
  try {
    const result = yield call(API.updateTeam, teamId, team);

    if (result.id) {
      yield put({ type: actionTypes.TEAM_UPDATE_SUCCESS, team: result });
    } else {
      yield put({ type: actionTypes.TEAM_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.TEAM_UPDATE_ERROR, error });
  }
}

export function* deleteTeam({ teamId }) {
  try {
    const result = yield call(API.deleteTeam, teamId);

    if (_.has(result, 'message') && result.message === false) {
      yield put({ type: actionTypes.TEAM_DELETE_ERROR, error: null });
    } else {
      yield put({ type: actionTypes.TEAM_DELETE_SUCCESS, teamId });
    }
  } catch (error) {
    yield put({ type: actionTypes.TEAM_DELETE_ERROR, error });
  }
}

export function* archiveTeam({ teamId }) {
  try {
    const result = yield call(API.archiveTeam, teamId);

    if (result.id) {
      yield put({ type: actionTypes.TEAM_ARCHIVE_SUCCESS, team: result });
    } else {
      yield put({ type: actionTypes.TEAM_ARCHIVE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.TEAM_ARCHIVE_ERROR, error });
  }
}

export function* recoverTeam({ teamId }) {
  try {
    const result = yield call(API.recoverTeam, teamId);

    if (result.id) {
      yield put({ type: actionTypes.TEAM_RECOVER_SUCCESS, team: result });
    } else {
      yield put({ type: actionTypes.TEAM_RECOVER_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.TEAM_RECOVER_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/teams.js